import { mergeOptions } from '../../helpers/common/merge-options';

export interface ClickableOptions {
	targetSelector: string;
	urlSelector: string;
}

export class Clickable {
	static options: ClickableOptions = {
		targetSelector: 'data-target',
		urlSelector: 'data-url'
	};

	private options: ClickableOptions;
	private target: string | null;
	private url: string | null;

	constructor(private element: HTMLElement, options?: Partial<ClickableOptions>) {
		this.options = mergeOptions(Clickable, options, element);

		this.target = this.element.getAttribute(this.options.targetSelector);
		this.url = this.element.getAttribute(this.options.urlSelector);

		this.element.addEventListener('click', (e: MouseEvent) => this.handleClick(e));
	}

	private handleClick(e: MouseEvent) {
		e.preventDefault();
		if ((e.target as Node).nodeName === 'A') {
			return;
		}
		if (!this.url) {
			return;
		}

		if (e.button === 2 || this.isTargetBlank()) {
			window.open(this.url, '_blank');
		} else {
			window.location.href = this.url;
		}
	}

	private isTargetBlank(): boolean {
		switch (this.target) {
			case '_blank':
			case 'blank':
				return true;
			default:
				return false;
		}
	}
}
